   <template>
   <div>

       <Header/>

<!--End mainmenu area--> 

<!--Start breadcrumb area-->

<section class="breadcrumb-area" v-bind:style="{backgroundImage: 'url('+this.pagebanner+ ')' }">
	<div class="container text-center">
		<h1 v-if="pagedata">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</h1>
		<span class="border"></span>
	</div>
</section>
<!--End breadcrumb area-->
         
<!--Start breadcrumb bottom area--> 
<section class="breadcrumb-bottom-area">
    <div class="container">
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <a href="#"></a>    
        </div>
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <ul>
               <li><a :href="$i18n.locale == 'en' ? '../../../../en/': '../../../../ar/'">{{ $i18n.locale == 'en' ? 'Home':'الرئيسية' }}</a></li>
               <li>></li>
                <li><a href="#">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</a></li>

                
            </ul>    
        </div>        
    </div>    
</section>         
<!--End breadcrumb bottom area-->
         
<!--Start faq content area-->
<section class="faq-content-area">
    <div class="container">
        <div class="row">
                <div class="faq-content-holder">
                    <div class="top">
                        <div class="title pull-left">
                            <div class="sec-title two">
                                <span class="border"></span>
                            </div>
                        </div>
                        <div class="search-question pull-right">
                            <form class="search-question-form" action="#">
                            </form>
                        </div>
                    </div>
                    <div class="text-holder">
                        <p v-html="$i18n.locale == 'en' ? pagedata.pagecontenten:pagedata.pagecontentar" >{{ $i18n.locale == 'en' ? pagedata.pagecontenten:pagedata.pagecontentar }}</p>
                    </div>
                    <div class="faq-content">
                        <div class="accordion-box">
                            <!--Start single accordion box-->
                            <div class="accordion accordion-block" v-for="contractcategory in contractcat" v-bind:key="contractcategory.id">
                                <div class="accord-btn" :style="$i18n.locale=='en'?'text-align: left!important;':'text-align: right'" ><h4 :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'"> {{ contractcategory.title }}</h4></div>
                                <div class="accord-content">
                                    <div class="table-responsive panel-body">
                                        <table  id= "contract" class="table  table-hover">
                                            <thead>
                                               <tr>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Category</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'"  scope="col">Instrument</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Description</th>
                                                <th v-if="contractcategory.id!=8  && contractcategory.id!=9" :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Spread in Pips</th>

                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Digits</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Tick Size</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col" >Contract Size</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Order Offset / Ticks</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Tick Value</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Margin Rate</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Margin Currency</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Min Volume</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Max Volume</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Step</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Trading Hours</th>
                                                <th :style="$i18n.locale=='en'?'text-align: left!important;padding-left:5%!important;':'text-align: right'" scope="col">Exceptions</th>
                                            </tr>
                                                    </thead>
                                                   <tbody v-for="contractspecdetailsdata in contractspecdetails"
                                                   v-bind:key="contractspecdetailsdata.id">

                                            <tr v-if="contractcategory.id==contractspecdetailsdata.catid">

                                                <td>{{ contractcategory.title }}</td>
                                                <td>{{ contractspecdetailsdata.instrument }}</td>
                                                <td>{{ contractspecdetailsdata.description }}</td>
                                                <td v-if="contractcategory.id!=8  && contractcategory.id!=9">{{ contractspecdetailsdata.spread_in_pips }}</td>
                                                <td>{{ contractspecdetailsdata.digits }}</td>
                                                <td>{{ contractspecdetailsdata.ticksize }}</td>
                                                <td>{{ contractspecdetailsdata.contractsize }}</td>
                                                <td>{{ contractspecdetailsdata.order_ticks }}</td>
                                                <td>{{ contractspecdetailsdata.tick_value }}</td>
                                                <td>{{ contractspecdetailsdata.margin_rate }}</td>
                                                <td>{{ contractspecdetailsdata.margin_currency }}</td>
                                                <td>{{ contractspecdetailsdata.min_volume }}</td>
                                                <td>{{ contractspecdetailsdata.max_volume }}</td>
                                                <td>{{ contractspecdetailsdata.step }}</td>
                                                <td width="150px" v-html="contractspecdetailsdata.trading_hours">{{ contractspecdetailsdata.trading_hours }}</td>
                                                <td>{{ contractspecdetailsdata.exceptions }}</td>
                                            </tr>

                                            </tbody>
                                        </table>
                                                        
                                                        </div>
                                </div>
                            </div>
                           
                           
                        </div>
                        </div>
                        </div>
                    </div>                 
                </div>    
            <div class="col-lg-3 col-md-4 col-sm-7 col-xs-12 pull-left">
                <div class="about-sidebar">
                    <!--End single sidebar--> 
                </div>
            </div>
</section>  
<!--End faq content area-->
	<!--Start slogan area-->
<section class="slogan-area">
    <div class="container">
        <div class="title pull-center">
            <h2>Join the largest network of financial services in Kuwait</h2>    
        </div>
        <div class="buttons pull-right">
        </div>
    </div>    
</section>
<!--End slogan area-->
<!--Start footer area-->  

    </div>
            <Footer/>
    </div>

</template>

<script>
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery-1.11.1.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.bxslider.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.countTo.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.appear.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/owl.carousel.min.js";

import  "https://wafrafrontend.marketequityinc.com/src/assets/js/validate.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.mixitup.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.easing.min.js";
import "http://maps.google.com/maps/api/js?sensor=true";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/fancyapps-fancyBox/source/jquery.fancybox.pack.js";		

import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.tools.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.revolution.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.actions.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.carousel.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.kenburn.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.layeranimation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.migration.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.navigation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.parallax.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.slideanims.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.video.min.js";




import "https://wafrafrontend.marketequityinc.com/src/assets/js/custom.js";
</script>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'Home',
    title: 'Home',
    data() {
        return {
            langs: ['en', 'ar'],
           
            homepageblocks: '',
            homeblock1: null,
            homeblockimage1: null,
            homepageblocksicons: [],
            homepageblocksicons3: [],
            homepageblocks2: '',
            ceomessage: '',
            successstories: '',
            slide1image:'',
            slide2image:'',
            slide3image:'',
            techanalysis:'',
            pagedata:'',
            pagebanner:'',
            contractcat :'',
            contractspecdetails:''
            

        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
          var pathvalues = (this.$route.path).split("/");
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'ar';
        }
       
        this.loadcontract();
      
        this.loadpagedata('contract');

    },
    mounted() {
        
        this.loadtechanalysis();
        this.loadpagedata('contract');

       
    },

    methods: {
 
       loadcontract() {

            this.$axios.get("http://devbackup.marketequityinc.com/loadcontractwafra",
            )
                .then(res => {
                    if (res) {

                        this.contractcat = res.data.contractcat;
                        this.contractspecdetails = res.data.contractspecdetails;
                       
                     // return true;


                    }
                  
                });
        },
       loadpagedata(pagename) {
            this.$axios.get("loadpagedata", {
                params: {
                    pagename: 'contract'
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                          if (res.data.code == 200) {
                        this.pagedata = res.data.pagedata[0];
                        this.pagebanner=this.serverurl+'/public/pagebanners/'+res.data.pagedata[0].pagebanner;
                          }
                        else{

                            this.$router.push({ name: 'NotFound' })
                        }
                    }
                });
            

        },

    }
}
</script>
<style>
#div1::after{
    clear: none!important;
    
}
.carousel {
  background: #2f435700!important;
}
    

    table th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #688ec5;;
        color: white;
    }

    .accordion-box .accordion .accord-btn::after {
        left: 13px!important;
    }
    .accordion-box .accordion .accord-btn h4{
        text-align:right!important;
    }
</style>
